import request from '@/plugins/axios'

// รายการสั่งซื้อพารามิเตอร์รายการอื่นๆ
export const apiOtherLists = () => request.get('/order.set_meal_order/searchParam')

// รายละเอียดการสั่งซื้อ
export const apiOrderDetail = (params: any) => request.get('/order.set_meal_order/detail', { params })

// รายการสั่งซื้อ
export const apiOrderLists = (params: any) => request.get('/order.set_meal_order/lists', { params })


// บันทึกการสั่งซื้อ
export const apiOrderRemarks = (params: any) => request.post('/order.set_meal_order/remark', params)

// ยืนยันการชำระเงิน
export const apiOrderConfirmPay = (params: any) => request.post('/order.set_meal_order/confirmPay', params)